import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config/api.js
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF for PDF generation
import 'jspdf-autotable'; // Import autoTable for tables in PDF

const OrderList = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [newStatus, setNewStatus] = useState('Pending'); // Default to Pending
    const [statusFilter, setStatusFilter] = useState(''); // For filtering tasks by status
    const navigate = useNavigate();

    const staffId = 1; // Replace with dynamic staff ID (e.g., from auth context or localStorage)

    const formatDate = (date) => {
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Fetching Orders based on Today's Date, Karigar Date, and Delivery Date
    useEffect(() => {
        setLoading(true);
        const date = '2025-02-25'; // Replace with dynamic date if needed

        const fetchData = async () => {
            try {
                const todayResponse = await fetch(`http://147.79.71.207:3125/api/orders/today?date=${date}`);
                const todayData = await todayResponse.json();
                if (todayData.status === 1) {
                    setOrders(todayData.data);
                    setFilteredOrders(todayData.data);
                } else {
                    setError('Failed to load today\'s orders');
                }

                const karigarResponse = await fetch(`http://147.79.71.207:3125/api/orders/karigar-date?date=${date}`);
                const karigarData = await karigarResponse.json();
                if (karigarData.status === 1) {
                    setOrders((prevOrders) => [...prevOrders, ...karigarData.data]);
                    setFilteredOrders((prevOrders) => [...prevOrders, ...karigarData.data]);
                } else {
                    setError('Failed to load Karigar orders');
                }

                const deliveryDateResponse = await fetch(`http://147.79.71.207:3125/api/orders/delivery-date?date=${date}`);
                const deliveryDateData = await deliveryDateResponse.json();
                if (deliveryDateData.status === 1) {
                    setOrders((prevOrders) => [...prevOrders, ...deliveryDateData.data]);
                    setFilteredOrders((prevOrders) => [...prevOrders, ...deliveryDateData.data]);
                } else {
                    setError('Failed to load delivery date orders');
                }
            } catch (err) {
                setError('Error fetching orders');
                console.error('Error fetching orders:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        filterOrders(term, startDate, endDate, statusFilter); // Apply search along with date and status filters
    };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };

    const handleStatusFilterChange = (event) => {
        const status = event.target.value;
        setStatusFilter(status);
        filterOrders(searchTerm, startDate, endDate, status); // Apply status filter along with search and date filters
    };

    const handleApplyFilter = () => {
        filterOrders(searchTerm, startDate, endDate, statusFilter); // Apply the date range and other filters
    };

    const filterOrders = (term, start, end, status) => {
        let filtered = orders.filter(order => {
            const matchesSearch = order.description.toLowerCase().includes(term.toLowerCase());

            // Convert order dates to YYYY-MM-DD format to avoid time parts interfering
            const orderDate = new Date(order.delivery_date).toISOString().split('T')[0]; // Format as YYYY-MM-DD

            const matchesDateRange = (
                (!start || new Date(orderDate) >= new Date(start)) && 
                (!end || new Date(orderDate) <= new Date(end))
            );

            const matchesStatus = status ? order.status === status : true; // Status filter condition

            return matchesSearch && matchesDateRange && matchesStatus; // Return orders that match all criteria
        });

        setFilteredOrders(filtered); // Update filtered orders state
    };

    const handleEdit = (id) => {
        navigate(`/EditOrder/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this order?")) {
            fetch(`${BASE_URL}orders/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setOrders(orders.filter(order => order.id !== id));
                        setFilteredOrders(filteredOrders.filter(order => order.id !== id));
                    } else {
                        alert('Failed to delete order');
                    }
                })
                .catch(error => {
                    alert('Error deleting order');
                    console.error('Error deleting order:', error);
                });
        }
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text('Order List', 14, 10);
        const tableData = filteredOrders.map(order => [
            order.description || 'N/A',
            order.weight || 'N/A',
            formatDate(order.delivery_date) || 'N/A',
            order.status || 'N/A',
            order.category_name || 'N/A',
            formatDate(order.created_at) || 'N/A',
            formatDate(order.updated_at) || 'N/A',
        ]);
        doc.autoTable({
            head: [['Description', 'Weight', 'Delivery Date', 'Status', 'Category', 'Created At', 'Updated At']],
            body: tableData,
        });
        doc.save('order_list.pdf');
    };

    const openStatusModal = (id) => {
        setSelectedOrderId(id);
        setStatusModalOpen(true);
    };

    const closeStatusModal = () => {
        setStatusModalOpen(false);
    };

    const handleStatusChange = (status) => {
        fetch(`http://147.79.71.207:3125/api/orders/${selectedOrderId}/status`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ status }), // Sending status in the request body
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 1) {
                const updatedOrders = orders.map(order =>
                    order.id === selectedOrderId ? { ...order, status: data.data.status } : order
                );
                setOrders(updatedOrders); // Update orders with the new status
                setFilteredOrders(updatedOrders); // Update filtered orders
                closeStatusModal(); // Close modal after update
            } else {
                alert('Failed to update order status');
            }
        })
        .catch(error => {
            console.error('Error updating order status:', error);
            alert('Error updating order status');
        });
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Order List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddOrder')}>Add Order</button>&nbsp;&nbsp;
                                        <button className="btn btn-secondary ms-2" onClick={handleExportPDF}>Export to PDF</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Search and Date Range Filter */}
                                <div className="mb-3 row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search by Description</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search order description"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="statusFilter" className="form-label">Filter by Status</label>
                                        <select
                                            id="statusFilter"
                                            className="form-select"
                                            value={statusFilter}
                                            onChange={handleStatusFilterChange}
                                        >
                                            <option value="">All</option>
                                            <option value="1">Pending</option>
                                            <option value="2">In Progress</option>
                                            <option value="3">Completed</option>
                                            <option value="4">Cancelled</option>
                                        </select>
                                    </div>
                                </div>
                                {/* Date Range Filter */}
                                <div className="mb-3 row">
                                    <div className="col-md-6">
                                        <label htmlFor="startDate" className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            id="startDate"
                                            className="form-control"
                                            value={startDate}
                                            onChange={handleStartDateChange}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="endDate" className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            id="endDate"
                                            className="form-control"
                                            value={endDate}
                                            onChange={handleEndDateChange}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 text-end">
                                    <button className="btn btn-secondary" onClick={handleApplyFilter}>Apply Filters</button>
                                </div>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Weight</th>
                                            <th>Delivery Date</th>
                                            <th>Status</th>
                                            <th>Category</th>
                                            <th>Created At</th>
                                            <th>Updated At</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredOrders.map(order => (
                                            <tr key={order.id}>
                                                <td>{order.description}</td>
                                                <td>{order.weight}</td>
                                                <td>{formatDate(order.delivery_date)}</td>
                                                <td>{order.status}</td>
                                                <td>{order.category_name}</td>
                                                <td>{formatDate(order.created_at)}</td>
                                                <td>{formatDate(order.updated_at)}</td>
                                                <td>
                                                    <button className="btn btn-primary" onClick={() => handleEdit(order.id)}>Edit</button>
                                                    <button className="btn btn-danger" onClick={() => handleDelete(order.id)}>Delete</button>
                                                    <button className="btn btn-info" onClick={() => openStatusModal(order.id)}>Change Status</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OrderList;
